import { createFileRoute } from "@tanstack/react-router";
import { PortalDomainDetailV2Page } from "@/components/v2/pages/portal-domain-detail-v2-page";

export const Route = createFileRoute("/portal/domains/$domainId")({
  component: PortalDomainDetailV2Page,
});
